import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../services/api';
import type { AiSettings, UpdateAiSettingsInput, TestAiSettingsResult } from '../types';

const aiSettingsKeys = {
  all: ['ai-settings'] as const,
};

export function useAiSettings() {
  return useQuery({
    queryKey: aiSettingsKeys.all,
    queryFn: () => api.get<AiSettings>('/ai-settings'),
    staleTime: 5 * 60 * 1000,
  });
}

export function useUpdateAiSettings() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateAiSettingsInput) =>
      api.put<AiSettings>('/ai-settings', data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: aiSettingsKeys.all });
      queryClient.invalidateQueries({ queryKey: ['cme', 'status'] });
    },
  });
}

export function useDeleteAiSettings() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => api.delete<AiSettings>('/ai-settings'),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: aiSettingsKeys.all });
      queryClient.invalidateQueries({ queryKey: ['cme', 'status'] });
    },
  });
}

export function useTestAiSettings() {
  return useMutation({
    mutationFn: () =>
      api.post<TestAiSettingsResult>('/ai-settings/test'),
  });
}
